<template>

</template>

<script>
  export default {
    name: 'Dialog_ParkingLot_Edit'
  }
</script>

<style scoped>

</style>
